import { Button, Tooltip } from "antd";
import { memo, useCallback } from "react";
import exceljs, { Alignment, CellValue } from "exceljs";
import { saveAs } from "file-saver";
import { Colors } from "../utils/colors";
import { FileExcelOutlined } from "@ant-design/icons";

const boniboLogoBase64 =
  "data:image/png;base64,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";

export interface ExlExpCellType {
  value: CellValue;
  dataType?: string; // "string" | "number" | "currency" | "percent" | "date" | "time";
  numFormat?: string;
  span?: number;
  rowSpan?: number;
  bold?: boolean;
  color?: string;
  fill?: string;
  fontSize?: number;
  alignment?: Partial<Alignment>;
}

export interface ExlExpDataType {
  theader: ExlExpCellType[][];
  tbody: { cells: ExlExpCellType[]; highlight?: boolean | string; bold?: boolean }[];
  columns?: { width?: number }[];
}

interface ExportToExcelProps {
  data: ExlExpDataType | (() => ExlExpDataType);
  title: string;
  fileName?: string;
  header?:
    | string
    | {
        value: CellValue;
        span?: number;
        color?: string;
        fill?: string;
        fontSize?: number;
        hAlign?: "left" | "center" | "right" | "fill" | "justify" | "centerContinuous" | "distributed";
        vAlign?: "top" | "middle" | "bottom" | "distributed" | "justify";
      };
  footer?:
    | string
    | {
        value: CellValue;
        span?: number;
        color?: string;
        fill?: string;
        fontSize?: number;
        hAlign?: "left" | "center" | "right" | "fill" | "justify" | "centerContinuous" | "distributed";
        vAlign?: "top" | "middle" | "bottom" | "distributed" | "justify";
      };
  stripedRows?: boolean;
  freeze?: {
    xSplit: number; // number of columns
    ySplit: number; // number of rows
  };

  source?: {
    url?: string;
    span?: number;
  };
  loading?: boolean;
  disabled?: boolean;
}

const correctSheetName = (name: string) =>
  name
    //.replaceAll(" ", "_")
    //.replaceAll("(", "")
    //.replaceAll(")", "")
    .replaceAll("*", "")
    .replaceAll("?", "")
    .replaceAll(":", "")
    .replaceAll("\\", "-")
    .replaceAll("/", "-")
    .replaceAll("[", "")
    .replaceAll("]", "");

const correctFileName = (name: string) =>
  name
    .replaceAll(" ", "_")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll("*", "")
    .replaceAll("?", "")
    .replaceAll(":", "")
    .replaceAll("\\", "")
    .replaceAll("/", "-")
    .replaceAll("[", "")
    .replaceAll("]", "");

const correctColorName = (name: string, light: boolean = false) => {
  if (name.startsWith("#")) return name.slice(1);
  switch (name) {
    case "default":
    default:
      return (light ? Colors.blue_200 : Colors.blue_700).slice(1);
    case "success":
      return (light ? Colors.green_200 : Colors.green_700).slice(1);
    case "warning":
      return (light ? Colors.orange_200 : Colors.orange_700).slice(1);
    case "danger":
      return (light ? Colors.red_200 : Colors.red_700).slice(1);
    case "info":
      return (light ? Colors.cyan_200 : Colors.cyan_700).slice(1);
    case "note":
      return (light ? Colors.yellow_200 : Colors.yellow_800).slice(1);
  }
};

export const ExportToExcel = memo(({ data, title, fileName, header, footer, stripedRows, freeze, source, loading, disabled }: ExportToExcelProps) => {
  const downloadExcel = useCallback(() => {
    const workbook = new exceljs.Workbook();

    workbook.creator = "Bonibo.ir";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet(correctSheetName(title), {
      views: [{ rightToLeft: true, state: freeze ? "frozen" : "normal", xSplit: freeze?.xSplit, ySplit: freeze?.ySplit }],
    });

    const finalData = typeof data === "function" ? data() : data;

    finalData.columns?.forEach((c, i) => {
      const sheetCol = worksheet.getColumn(i + 1);
      sheetCol.width = c.width;
    });

    let sheetRowIndex = 1;

    if (header) {
      worksheet.mergeCells(
        sheetRowIndex,
        1,
        sheetRowIndex + 1,
        typeof header === "object" && header.span ? header.span : (finalData.columns?.length ?? 5),
      );
      const headerRow = worksheet.getRow(sheetRowIndex);
      const headerCell = headerRow.getCell(1);
      headerCell.font = {
        size: typeof header === "object" && header.fontSize ? header.fontSize : 12,
        bold: true,
        color: { argb: typeof header === "object" && header.color ? correctColorName(header.color) : correctColorName(Colors.grey_600) },
      };

      headerCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: typeof header === "object" && header.fill ? correctColorName(header.fill) : correctColorName(Colors.white) },
      };

      headerCell.border = {
        top: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        left: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        bottom: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        right: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
      };

      headerCell.alignment = {
        horizontal: typeof header === "object" && header.hAlign ? header.hAlign : "right",
        vertical: typeof header === "object" && header.vAlign ? header.vAlign : "middle",
        indent: 1,
        readingOrder: "rtl",
      };

      headerCell.value = typeof header === "object" ? header.value : header;
      sheetRowIndex += 2;
    }

    finalData.theader.forEach((theaderRow, i) => {
      const sheetRow = worksheet.getRow(sheetRowIndex);

      let sheetCellIndex = 1;
      theaderRow.forEach((headerCell) => {
        if (headerCell.span && headerCell.span > 1) {
          worksheet.mergeCells(sheetRowIndex, sheetCellIndex, sheetRowIndex, sheetCellIndex + headerCell.span - 1);
        }
        if (headerCell.rowSpan && headerCell.rowSpan > 1) {
          worksheet.mergeCells(sheetRowIndex, sheetCellIndex, sheetRowIndex + headerCell.rowSpan - 1, sheetCellIndex);
        }
        const sheetCell = sheetRow.getCell(sheetCellIndex);
        sheetCell.value = headerCell.value;
        sheetCell.alignment = { wrapText: true, shrinkToFit: true, vertical: "middle", ...headerCell.alignment };
        // horizontal: "center"
        sheetCell.font = {
          bold: headerCell.bold ?? true,
          size: headerCell.fontSize,
          color: { argb: headerCell.color ? correctColorName(headerCell.color) : undefined },
        };

        sheetCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerCell.fill ? correctColorName(headerCell.fill) : "e0e0e0" } };

        sheetCell.border = {
          top: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
          left: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
          bottom:
            i === finalData.theader.length - 1
              ? { style: "thick", color: { argb: correctColorName(Colors.grey_600) } }
              : { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
          right: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        };
        sheetCellIndex += headerCell.span ?? 1;
      });

      sheetRowIndex++;
    });

    finalData.tbody.forEach((tbodyRow, i) => {
      const sheetRow = worksheet.getRow(sheetRowIndex);
      let sheetCellIndex = 1;
      tbodyRow.cells
        .filter((x) => x.span === undefined || x.span > 0)
        .forEach((tbodyCell) => {
          if (tbodyCell.span && tbodyCell.span > 1) {
            worksheet.mergeCells(sheetRowIndex, sheetCellIndex, sheetRowIndex, sheetCellIndex + tbodyCell.span - 1);
          }
          if (tbodyCell.rowSpan && tbodyCell.rowSpan > 1) {
            worksheet.mergeCells(sheetRowIndex, sheetCellIndex, sheetRowIndex + tbodyCell.rowSpan - 1, sheetCellIndex);
          }
          const sheetCell = sheetRow.getCell(sheetCellIndex);

          sheetCell.value = tbodyCell.value;
          sheetCell.alignment = { wrapText: true };

          if (tbodyCell.value && typeof tbodyCell.value === "number") {
            if (tbodyCell.dataType === "number") {
              if (tbodyCell.value > -1 && tbodyCell.value < 1) {
                sheetCell.numFmt = "#,##0.0";
              } else {
                sheetCell.numFmt = "#,##0";
              }
            } else if (tbodyCell.dataType === "currency") {
              if (tbodyCell.value > -10 && tbodyCell.value < 10) {
                sheetCell.numFmt = "#,##0.0";
              } else {
                sheetCell.numFmt = "#,##0";
              }
            } else if (tbodyCell.dataType === "percent") {
              if (tbodyCell.value > -10 && tbodyCell.value < 10) {
                sheetCell.numFmt = "0.0%";
              } else {
                sheetCell.numFmt = "0%";
              }
              sheetCell.value = tbodyCell.value / 100; // because excel percentage multiplied by 100
            }
          } else if (Number.isNaN(tbodyCell.value)) {
            sheetCell.value = { formula: "NA()" };
            sheetCell.alignment = { ...sheetCell.alignment, horizontal: "right" };
          } else if (tbodyCell.value === " ") {
            sheetCell.value = " ";
          }

          if (tbodyCell.numFormat) {
            sheetCell.numFmt = tbodyCell.numFormat;
          }
          if (stripedRows) {
            sheetCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: i % 2 ? correctColorName(Colors.grey_200) : correctColorName(Colors.white) },
            };
          }
          if (tbodyRow.highlight) {
            sheetCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: typeof tbodyRow.highlight === "string" ? correctColorName(tbodyRow.highlight) : correctColorName(Colors.grey_200),
              },
            };
          }

          sheetCell.font = {
            size: tbodyCell.fontSize,
            color: tbodyCell.color ? { argb: correctColorName(tbodyCell.color) } : undefined,
            bold: tbodyRow.bold ?? tbodyCell.bold,
          };

          if (tbodyCell.fill) {
            sheetCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: correctColorName(tbodyCell.fill) } };
          }

          sheetCell.border = {
            top: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
            left: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
            bottom: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
            right: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
          };

          if (tbodyCell.alignment) {
            sheetCell.alignment = { ...sheetCell.alignment, ...tbodyCell.alignment };
          }

          sheetCellIndex += tbodyCell.span ?? 1;
        });

      sheetRowIndex++;
    });

    if (footer) {
      worksheet.mergeCells(sheetRowIndex, 1, sheetRowIndex + 1, typeof footer === "object" && footer.span ? footer.span : 5);
      const footerRow = worksheet.getRow(sheetRowIndex);
      const footerCell = footerRow.getCell(1);
      footerCell.font = {
        size: typeof footer === "object" && footer.fontSize ? footer.fontSize : 11,
        bold: true,
        color: { argb: typeof footer === "object" && footer.color ? correctColorName(footer.color) : correctColorName(Colors.grey_600) },
      };

      footerCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: typeof footer === "object" && footer.fill ? correctColorName(footer.fill) : correctColorName(Colors.white) },
      };

      footerCell.alignment = {
        horizontal: typeof footer === "object" && footer.hAlign ? footer.hAlign : "right",
        vertical: typeof footer === "object" && footer.vAlign ? footer.vAlign : "middle",
        indent: 1,
      };

      footerCell.border = {
        top: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        left: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        bottom: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
        right: { style: "thin", color: { argb: correctColorName(Colors.grey_400) } },
      };

      footerCell.value = typeof footer === "object" ? footer.value : footer;
      sheetRowIndex += 2;
    }

    sheetRowIndex = sheetRowIndex + 1;
    worksheet.mergeCells(sheetRowIndex, 1, sheetRowIndex + 1, source?.span || 2);
    const logoRow = worksheet.getRow(sheetRowIndex);
    const logoCell = logoRow.getCell(1);

    logoCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: correctColorName(Colors.grey_50) },
    };
    logoCell.border = {
      top: { style: "thin", color: { argb: "224EA4" } },
      left: { style: "thin", color: { argb: "224EA4" } },
      bottom: { style: "thin", color: { argb: correctColorName(Colors.grey_50) } },
      right: { style: "thin", color: { argb: "224EA4" } },
    };

    const boniboLogo = workbook.addImage({
      base64: boniboLogoBase64,
      extension: "png",
    });

    worksheet.addImage(boniboLogo, {
      tl: { col: 0.5, row: sheetRowIndex - 0.25 },
      ext: { width: 147, height: 32 },
    });

    sheetRowIndex = sheetRowIndex + 2;
    worksheet.mergeCells(sheetRowIndex, 1, sheetRowIndex + 1, source?.span || 2);

    const logoTextRow = worksheet.getRow(sheetRowIndex);
    const logoTextCell = logoTextRow.getCell(1);
    logoTextCell.alignment = { horizontal: "right", vertical: "middle", indent: 3 };
    logoTextCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: correctColorName(Colors.grey_50) },
    };
    logoTextCell.border = {
      top: { style: "thin", color: { argb: correctColorName(Colors.grey_50) } },
      left: { style: "thin", color: { argb: "224EA4" } },
      bottom: { style: "thin", color: { argb: "224EA4" } },
      right: { style: "thin", color: { argb: "224EA4" } },
    };

    logoTextCell.font = {
      size: 12,
      bold: true,
      color: { argb: "224EA4" },
      underline: true,
    };

    logoTextCell.value = { text: "منبع: وب‌سایت بونیبو", hyperlink: source?.url || window.location.href };

    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${correctFileName(fileName ?? title)}.xlsx`);
    });
  }, [title, freeze, data, header, footer, source?.span, source?.url, stripedRows, fileName]);

  return (
    <Tooltip title="خروجی اکسل" placement="right">
      <Button disabled={disabled} size="small" icon={<FileExcelOutlined />} loading={loading} onClick={downloadExcel}>
        خروجی اکسل
      </Button>
    </Tooltip>
  );
});

ExportToExcel.displayName = "ExportToExcel";
